// React
import { useState } from "react";
import { useNavigate } from "react-router-dom";
// Style
import "../../styles/menu/PaymentStyle.scss";
// Recoil
import { cartState, orderState, paymentData } from "../../atom/menu";
import { useRecoilState, useRecoilValue } from "recoil";

function PaymentSelect() {
  // 결제 방법 선택 화면

  const navigate = useNavigate();
  // Recoil State
  const cartData = useRecoilValue(cartState);
  const payment = useRecoilValue(paymentData);
  const [orderData, setOrderData] = useRecoilState(orderState);
  // useState
  const [isPopup, setIsPopup] = useState(false);
  const [isCard, setIsCard] = useState(false);

  // Function
  const setPayType = (payType: string) => {
    if (cartData && orderData) {
      const prevArray = [...orderData!.orderData];
      let rewardPoint = 0;
      if (payType === "cash") {
        rewardPoint = calcTotalAmount() * 0.06;
      } else {
        rewardPoint = calcTotalAmount() * 0.04;
      }
      prevArray.unshift({
        orderData: cartData,
        payment: { ...payment, payType: payType, rewardPoint: rewardPoint },
        orderTime: `${
          new Date().getHours() < 10
            ? "0" + new Date().getHours()
            : new Date().getHours()
        }:${
          new Date().getMinutes() < 10
            ? "0" + new Date().getMinutes()
            : new Date().getMinutes()
        }:${
          new Date().getSeconds() < 10
            ? "0" + new Date().getSeconds()
            : new Date().getSeconds()
        }`,
      });
      setOrderData({ ...orderData!, orderData: [...prevArray] });
      movePage(payType);
    }
  };
  const movePage = (payType: string) => {
    if (payType === "cash") {
      navigate("/menu/order/payment/cash");
    } else if (payType === "card") {
      setIsCard(true);
      setTimeout(() => {
        navigate("/menu/order/payment/success");
      }, 3000);
    } else if (payType === "kakao") {
      navigate("/menu/order/payment/kakao");
    } else if (payType === "npay") {
      navigate("/menu/order/payment/npay");
    }
  };

  function calcTotalAmount() {
    if (cartData) {
      let amt = 0 as number;
      let option = 0 as number;
      cartData.reduce((acc, cur) => {
        amt = acc + cur.price * cur.ea;
        if (cur.option) {
          cur.option.reduce((acc2, cur2) => {
            option = acc2 + cur2.price * cur2.ea;
            return option;
          }, option);
        }
        return amt;
      }, amt);
      let total = (amt + option) as number;
      return total;
    } else return 0;
  }

  return (
    <>
      <div className='intro-wrap'>
        <img
          className='absolute-logo'
          src={"/assets/images/menu/logo.png"}
          alt='vd company logo'
          style={{ width: 158 }}
        />

        <div
          className='payment-select-wrap'
          style={{ paddingTop: 120, gap: 32 }}
        >
          <div className='TO-title-1 text-color-gray'>
            {calcTotalAmount()?.toLocaleString()} 원을 결제합니다
          </div>
          <div className='payment-type-wrap'>
            <div
              className='payment-type-box'
              onClick={() => {
                setIsPopup(true);
              }}
            >
              <div className='type-img-box'>
                <img
                  src={"/assets/images/menu/cash.png"}
                  alt='payment for cash'
                />
              </div>
              <div className='TO-title-2 text-color-gray-3'>현금결제</div>
            </div>
            <div
              className='payment-type-box'
              onClick={() => {
                setPayType("card");
              }}
            >
              <div className='type-img-box'>
                <img
                  src={"/assets/images/menu/card.svg"}
                  alt='payment for card'
                />
              </div>
              <div className='TO-title-2 text-color-gray-3'>카드결제</div>
            </div>
            <div
              className='payment-type-box'
              onClick={() => {
                setPayType("kakao");
              }}
            >
              <div className='type-img-box'>
                <img
                  src={"/assets/images/menu/kakaopay.svg"}
                  alt='payment for kakaopay'
                />
              </div>
              <div className='TO-title-2 text-color-gray-3'>카카오페이</div>
            </div>
            <div
              className='payment-type-box'
              onClick={() => {
                setPayType("npay");
              }}
            >
              <div className='type-img-box'>
                <img
                  src={"/assets/images/menu/npay.png"}
                  alt='payment for n'
                  style={{ width: 153 }}
                />
              </div>
              <div className='TO-title-2 text-color-gray-3'>카드분할결제</div>
            </div>
          </div>
          <div
            className='basic-btn white TO-button-1 pointer'
            style={{ alignSelf: "flex-start" }}
            onClick={() => {
              navigate("/menu/order/membership");
            }}
          >
            이전으로
          </div>
        </div>
      </div>
      {isPopup && (
        <div className='menu-popup-bg'>
          <div className='flex col center' style={{ padding: 40, gap: 64 }}>
            <div
              className='TO-title-1 text-color-gray-3'
              style={{ textAlign: "center" }}
            >
              직원이 바쁜 경우 결제가 지연될 수 있습니다.
              <br />
              그래도 현금으로 결제하시겠습니까?
            </div>
            <div className='menu-intro-button'>
              <div
                className='basic-btn white TO-button-1 pointer'
                style={{ maxWidth: 324 }}
                onClick={() => {
                  setIsPopup(false);
                }}
              >
                취소
              </div>
              <div
                className='basic-btn TO-button-1 pointer'
                style={{ maxWidth: 324 }}
                onClick={() => {
                  setPayType("cash");
                }}
              >
                확인
              </div>
            </div>
          </div>
        </div>
      )}

      {isCard && (
        <div
          className='menu-popup-bg'
          style={{ backgroundColor: "rgba(0, 0, 0, 0.7", zIndex: 99 }}
        >
          <div
            className='menu-popup-inner-wrap'
            style={{ width: 885, backgroundColor: "#eaeaea" }}
          >
            <div className='flex col center' style={{ padding: 62, gap: 32 }}>
              <img
                src={"/assets/images/menu/creditcard.svg"}
                alt='creditcard'
              />
              <div
                className='TO-title-1'
                style={{ textAlign: "center", color: "#010101" }}
              >
                카드를 리더기에 꽂아주세요
              </div>
              <div className='flex row center' style={{ gap: 16 }}>
                <img
                  src={"/assets/images/menu/timer.png"}
                  alt='timer'
                  style={{ width: 40 }}
                />
                <div className='TO-body-3'>결제시도중입니다...</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
export default PaymentSelect;
